module.exports = __webpack_public_path__ + "img/donante-tips.220c4be3.png";